// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cinema-text[data-v-12f34d7d]{margin-block:32px}.cinema-text__heading[data-v-12f34d7d]{margin:0 0 16px;font-weight:700;text-transform:uppercase;font-size:16px;color:#6a7c8f}.cinema-text p[data-v-12f34d7d]{margin:16px 0 0}", ""]);
// Exports
module.exports = exports;
